import { IconCurrencyCircleDollar } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import type { ItemPriceRange as ItemPriceRangeType } from 'typings'
import { useDrawerState, useFormStateContext } from '../../../..'
import { useConditions } from '../useConditions'
import { Editor } from './Editor'
import { messages } from './messages'
import { ItemPriceRangeView } from './View'

interface Props {
  name: string
}

export function ItemPriceRange(props: Props) {
  const { name } = props
  const { $t } = useIntl()

  const { form, discountType } = useFormStateContext()
  const config: ItemPriceRangeType | undefined = useWatch({ form, name })

  const editorState = useDrawerState()

  useConditions({
    name,
    onEdit: editorState.show,
    label: $t(messages.name),
    icon: <IconCurrencyCircleDollar />,
  })

  const handleRemove = () => form.setValue(name, undefined)

  const handleSave = (values: ItemPriceRangeType) => form.setValue(name, values)

  return (
    <>
      <ItemPriceRangeView
        config={config}
        onEdit={editorState.show}
        onRemove={handleRemove}
      />
      <Editor
        state={editorState}
        initialConfig={config}
        discountType={discountType}
        onSave={handleSave}
      />
    </>
  )
}
